import * as React from "react";

import type { TextLanguage } from "Store/texts/interfaces";
import { CustomerStatus } from "Store/userIdentification/userIdentificationInterfaces";
import { indexToCustomerStatus } from "../utils/customerStatusMapper";
import { CustomerTooYoung } from "./CustomerTooYoung";
import { GeneralBlocking } from "./GeneralBlocking";

interface Props {
  readonly status: number;
  readonly texts: any;
  readonly lang: TextLanguage;
}

export const Multiplexer = (props: Props): React.ReactElement => {
  const { status, texts, lang } = props;
  const [customerStatus] = React.useState(() => indexToCustomerStatus(status));

  if (CustomerStatus.CUSTOMER_TOO_YOUNG === customerStatus) {
    return <CustomerTooYoung texts={texts} lang={lang} />;
  }

  return <GeneralBlocking texts={texts} lang={lang} />;
};
